import {marketingWebsocketCommands} from '../../constants/marketingWebsocketCommands';
import get from 'get-value';

export const marketingFullTextSearch = (state = {
    correlationId: null,
    isLoading: false,
    isTableLoading: false,
    fullTextData: [],
    pages: 0,
    isNextFromPivot: true,
    isNextPage: false,
    isLoadingLastEditors: false,
    lastEditors: []
}, action) => {
    switch (action.type) {
        case marketingWebsocketCommands.MARKETING_FULL_TEXT_SEARCH_GET: {
            return Object.assign({}, state, {isTableLoading: true, fullTextData: []});
        }
        case marketingWebsocketCommands.MARKETING_FULL_TEXT_SEARCH_FETCH_SUCCESS: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isTableLoading: false,
                    fullTextData: get(action, 'payload.result.data', {default: []}),
                    pages: get(action, 'payload.result.pages', {default: 0}),
                    isNextFromPivot: get(action, 'payload.result.isNextFromPivot', false),
                    isNextPage: get(action, 'payload.result.isNextPage', false),
                    correlationId
                });
            }
        }
        case marketingWebsocketCommands.MARKETING_FULL_TEXT_SEARCH_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {isTableLoading: false, fullTextData: [], correlationId});
            }
        }
        default:
            return state;
    }
};
